<app-header-one [sticky]="true"></app-header-one>
<section class="section-b-space">
    <div class="job">
        <h2><b>{{rowDetails.job_title}}</b></h2>
    </div>
    <div class="job_exp">
        <p>Experience: {{rowDetails.exp_required}}</p>
        <p>Location: {{rowDetails.job_location}}</p>
    </div>
    <div class="apply">
        <div class="col-lg-4"></div>
        <div class="apply-btn">
            <div class="col-lg-3" class="job_description">
                <p><b>Last date to apply:</b> {{rowDetails.job_end_date | date: 'EEEE, MMM d, y' }} </p>
            </div>
            <div class="col-lg-12">
                <button class="btn btn-solid" *ngIf="rowDetails.application_method === 'WHITEROBE'"
                    (click)="openFormModal()" style="float: right;">Apply now</button>
                <button class="btn btn-solid" *ngIf="rowDetails.application_method === 'ONLINE'"
                    [attr.href]="rowDetails.application_link" (click)="openInNewTab(rowDetails.application_link)"
                    style="float: right;">Apply
                    now</button>
            </div>

        </div>

    </div>

    <div class="row"></div>

    <section class="login-page section-b-space padding-0">
        <div class="theme-card">
            <mat-tab-group>
                <mat-tab label="Description">
                    <div class="job_description">
                        <p><b>Industry:</b> {{rowDetails.job_category}} </p>
                        <p><b>Job description:</b> {{getPlainText(rowDetails.job_description)}} </p>
                        <p><b>Benifits:</b> {{getPlainText(rowDetails.job_benefits)}} </p>
                    </div>


                </mat-tab>
                <mat-tab label="Eligibility">
                    <div class="job_description">
                        <p><b>Qualification:</b> {{rowDetails.required_qualification}}</p>
                        <p><b>Skills:</b> {{rowDetails.required_skills}}</p>
                    </div>


                </mat-tab>
                <mat-tab label="Process" class="">
                    <div class="job_description">
                        <p> {{getPlainText(rowDetails.job_description)}}</p>
                    </div>

                </mat-tab>
            </mat-tab-group>

        </div>
    </section>
    <!-- {{applicationLink | json}} -->
    <div class="row"></div>
    <section *ngIf="applicationLink" class="login-page section-b-space padding-0">

        <div class="dashboard-right">
            <div class="dashboard">
                <div class="page-title">
                    <h2 style="text-align: center;">Apply Now</h2>
                </div>
            </div>
        </div>

    </section>
    <ng-template #applyFormDialog>
        <section style="padding: 2.5rem;">
            <form [formGroup]="form">
                <div class="theme-card">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group form-group-change">
                                <mat-form-field appearance="outline" class="custom-width">
                                    <mat-label>Name(as per govt ID)</mat-label>
                                    <input matInput type="text" formControlName="name" />
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group form-group-change">
                                <mat-form-field appearance="outline" class="custom-width">
                                    <mat-label>Email</mat-label>
                                    <input matInput type="text" formControlName="email" />
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group form-group-change">
                                <mat-form-field appearance="outline" class="custom-width">
                                    <mat-label>Mobile</mat-label>
                                    <input matInput type="number" formControlName="primary_number" />
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group form-group-change">
                                <mat-form-field appearance="outline" class="custom-width">
                                    <mat-label>DOB</mat-label>
                                    <input matInput [matDatepicker]="picker" formControlName="dob"
                                        (click)="picker.open()" readonly />
                                    <mat-datepicker-toggle matSuffix [for]="picker"
                                        class="date-toggle-icon"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>

                                    <mat-error
                                        *ngIf="form.get('dob')?.hasError('required') && form.get('dob')?.touched">
                                        Date of Birth is required.
                                    </mat-error>
                                    <mat-error
                                        *ngIf="form.get('dob')?.hasError('ageTooYoung') && form.get('dob')?.touched">
                                        Age should be 18 or older.
                                    </mat-error>
                                    <mat-error
                                        *ngIf="form.get('dob')?.hasError('futureDob') && form.get('dob')?.touched">
                                        DOB cannot be in the future.
                                    </mat-error>
                                </mat-form-field>

                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group form-group-change">
                                <mat-form-field appearance="outline">
                                    <mat-label>Address</mat-label>
                                    <textarea rows="3" matInput formControlName="address"></textarea>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group form-group-change">
                                <mat-form-field appearance="outline" class="custom-width">
                                    <mat-label>Secondary number</mat-label>
                                    <input matInput type="number" formControlName="secondary_number" />
                                </mat-form-field>
                            </div>
                        </div>

                    </div>
                    <div>
                        <div class="file-upload-container">
                            <button class="btn btn-solid" mat-fab extended (click)="fileInput.click()">
                                <mat-icon>cloud</mat-icon>
                                Upload file
                                <input class="choose_button" type="file" (change)="onFileSelected($event)"
                                    accept=".pdf, .doc, .docx" #fileInput style="display: none;" />
                            </button>
                            <mat-icon style="padding-left: 2%;" class="mat-icon-info-custom"
                                matTooltip="PDF, DOCX files are accepted" aria-hidden="false"
                                aria-label="Info icon">info</mat-icon>
                            <p>{{selectedFileName}}</p>

                        </div>
                    </div>
                    <div>
                        <p style="color: var(--primary-color); margin: 1rem;">
                            Note: Only JPEG, JPG, and PNG files are allowed for upload.</p>
                    </div>
                </div>
            </form>
            <div class="row">
                <div class="col-lg-9"></div>
                <div class="col-lg-3">
                    <button type="submit" class="btn btn-solid" (click)="createJobsAdvertsApplication()">Submit</button>
                </div>
            </div>
        </section>
    </ng-template>
    <app-footer-one></app-footer-one>